export default {
  de: {
    title: 'Neue Funktion hinzufügen',
    name: 'Name',
    submit: 'Funktion erstellen',
    back: 'Zurück',
    alerts: {
      500: () => 'Ein unbekannter Fehler ist aufgetretten! Bitte versuchen Sie es in kürze erneut!',
    },
  },
};
